import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_SOCKET_HOST, {
    transports: ["websocket"],
    // withCredentials: true,
});

export const SOCKET_EVENT = {
    SYSTEM: {
        connect: "connect",
        connect_error: "connect_error",
        disconnect: "disconnect",
    },
    ON: {
        MESSAGE_RECEIVE: "MESSAGE:RECEIVE",
        USER_NOTIFICATION_RECEIVE: "USER_NOTIFICATION:RECEIVE",
    },
    EMMIT: {
        THREAD_JOIN: "THREAD:JOIN",
        THREAD_LEAVE: "THREAD:LEAVE",
        MESSAGE_SEND: "MESSAGE:SEND",
        USER_NOTIFICATION_JOIN: "USER_NOTIFICATION:JOIN",
        USER_NOTIFICATION_LEAVE: "USER_NOTIFICATION:LEAVE",
        USER_NOTIFICATION_SEND: "USER_NOTIFICATION:SEND",
    },
};
